/**
 * Custom Divider Component
 * Extends Ant Design Divider with custom styling
 */

import { Divider as AntDivider, DividerProps } from 'antd';
import classNames from 'classnames';
import './CustomDivider.scss';

export interface CustomDividerProps extends Omit<DividerProps, 'variant'> {
  /** Divider variant */
  dividerVariant?: 'default' | 'dashed' | 'gradient';
}

/**
 * CustomDivider Component
 */
export const CustomDivider: React.FC<CustomDividerProps> = ({
  dividerVariant = 'default',
  className,
  ...rest
}) => {
  const dividerClasses = classNames('custom-divider', `custom-divider--${dividerVariant}`, className);

  return <AntDivider {...rest} className={dividerClasses} />;
};

export default CustomDivider;

